// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2Yc3T","rootSuccess":"CompleteLink_rootSuccess__2QAG6","rootFailure":"CompleteLink_rootFailure__1sJvx","isDisabled":"CompleteLink_isDisabled__3jPwN"};